var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5999 9.44961H4.2499L11.2999 2.39961C11.7499 1.94961 11.7499 1.19961 11.2999 0.749609C10.8499 0.299609 10.2499 0.299609 9.7999 0.749609L0.799902 9.74961C0.349902 10.1996 0.349902 10.9496 0.799902 11.3996L9.7999 20.3996C10.2499 20.8496 10.9999 20.8496 11.4499 20.3996C11.8999 19.9496 11.8999 19.3496 11.4499 18.8996L4.3999 11.6996H20.7499C21.3499 11.6996 21.9499 11.2496 21.9499 10.4996C21.6499 9.89961 21.1999 9.29961 20.5999 9.44961Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrow-back.712872c8052fd8405c76502b4a82241e.svg";
export { ForwardRef as ReactComponent };